import { createReceive } from '../clients';

export const receiveSession = createReceive('session');
